import { Stack, Typography } from "@mui/material";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import type { CompanyWithAccess } from "../definitions";
import CompanyProductDetails from "./CompanyProductDetails";
import InviteMembersContext from "./InviteMembersContext";

interface Props {
  company: CompanyWithAccess;
}

const CompanyProducts = ({ company }: Props) => {
  const { getAvailableProductsWithRoles } = useDefinedContext(InviteMembersContext);

  const productsWithRoles = getAvailableProductsWithRoles(company.clientCode);

  return (
    <Stack direction="row" spacing={4} sx={{ justifyItems: "center", alignItems: "center" }}>
      <Typography sx={{ width: "3rem" }} variant="subtitle2">
        Products
      </Typography>
      {!company.roles.length && <Typography sx={{ color: "error.light" }}>Set product access</Typography>}
      <Stack
        direction="row"
        spacing={3}
        useFlexGap
        sx={{ justifyItems: "center", alignItems: "center", flexWrap: "wrap" }}
      >
        {productsWithRoles
          .filter((accessPermission) => company.roles.some((role) => accessPermission.roles.includes(role)))
          .map((accessPermission) => (
            <CompanyProductDetails key={accessPermission.key} product={accessPermission} grantedRoles={company.roles} />
          ))}
      </Stack>
    </Stack>
  );
};

export default CompanyProducts;
